// Import the necessary components
import { Mapper } from 'js-data'
import PagedCollection from './PagedCollection'
import get from 'lodash/get'

// Wrap the find all to get a collection
class BaseMapper extends Mapper {
  /**
   * This method works in conjunction with VerofreshApiAdapter.deserialize. When
   * we get a collection from the API we shove the headers (which includes page
   * information) into this first item in the collection (it was the cleanest
   * way I could come up with to get at this data). This method removes those
   * response headers and then creates the PagedCollection passing in the
   * records and headers
   *
   * @param {*} query
   * @param {*} opts
   */
  findAll (query, opts) {
    return super.findAll(query, opts).then(function (records) {
      let responseHeaders = {}
      if (records.length > 0 && records[0].responseHeaders) {
        responseHeaders = records[0].responseHeaders
        delete records[0].responseHeaders
        if (Object.keys(records[0]).length === 0) {
          records = []
        }
      }
      return new PagedCollection(records, responseHeaders)
    })
  }

  /**
   * Utility method to which evaluates the properties passed in and if the props
   * object includes the primary key (currently hardcoded to id) then update is
   * called, otherwise a new resource is created.
   *
   * TODO: Implement a better way to determine the primary key
   *
   * @param Object props attributes of the object (becomes JSON body payload)
   * @param Object opts optional get parameters to pass up with the request
   */
  createOrUpdate (props, opts) {
    if (props.id === undefined) {
      return super.create(props, opts)
    } else {
      return super.update(props.id, props, opts)
    }
  }

  /**
   * Override Mapper.toJSON to automatically update belongsTo foreign keys before converting to JSON
   * @param record
   * @param opts
   * @returns {{}}
   */
  toJSON (record, opts) {
    this.updateBelongsToFKs(record)
    return super.toJSON(record, opts)
  }

  /**
   * Given a record, automatically update the foreign key for any belongsTo
   * relation so that it matches the id of the object in the relation localField
   * (assuming there is a valid object there.)
   *
   * @param record
   */
  updateBelongsToFKs (record) {
    const belongsTo = get(this.relations, 'belongsTo', {})
    Object.keys(belongsTo).forEach(relationName => {
      this.updateRelationFKs(record, 'belongsTo', relationName)
    })
  }

  /**
   * Update the foreign key values pertaining to a particular relation.
   * This is useful in toJSON mapping to convert from relation objects,
   * which we will often use client-side, to FK ids, which will be used server-side.
   *
   * This functionality might already be in js-data in some form, but doesn't seem to be.
   *
   * @param record the record to perform this operation on.
   * @param relationType the type of relation (belongsTo, hasOne, hasMany)
   * @param relationName the name of the relation definition
   */
  updateRelationFKs (record, relationType, relationName) {
    const meta = get(this.relations, [relationType, relationName])
    if (meta && record[meta.localField]) {
      if (meta.type === 'belongsTo') {
        record[meta.foreignKey] = record[meta.localField].id
      }
      if (meta.type === 'hasOne') {
        record[meta.localField][meta.foreignKey] = record.id
      }
      if (meta.type === 'hasMany') {
        record[meta.localField].forEach(item => {
          item[meta.foreignKey] = record.id
        })
      }
    }
  }
}
export default BaseMapper
